import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StatusTraveller } from '@/img/reservation_page/status-traveller.svg';
import { ReactComponent as StatusSilver } from '@/img/reservation_page/status-silver.svg';
import { ReactComponent as StatusGold } from '@/img/reservation_page/status-gold.svg';
import { ReactComponent as StatusPlatinum } from '@/img/reservation_page/status-platinum.svg';
import { ReactComponent as StatusTopPlatinum } from '@/img/reservation_page/status-top-platinum.svg';
import { getStatusTiers } from 'arbitrip-common/client/utils/PointsAndDiamondsUtils';

const PointsAndDiamondsDialog = ({ open, onClose }) => {
    const { t } = useTranslation();

    const statusTiers = getStatusTiers(t, {
        StatusTraveller,
        StatusSilver,
        StatusGold,
        StatusPlatinum,
        StatusTopPlatinum,
    });

    const renderStatusLabel = (label, colorClass) => {
        // Split label by space to separate status name from tier code (e.g., "TRAVELLER TL" -> ["TRAVELLER", "TL"])
        const parts = label.split(' ');
        const statusName = parts[0];
        const tierCode = parts.slice(1).join(' ');

        return (
            <>
                <span
                    className={`points-and-diamonds-dialog__status-name points-and-diamonds-dialog__status-name--${colorClass}`}
                >
                    {statusName}
                </span>
                {tierCode && <span> {tierCode}</span>}
            </>
        );
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth 
            className="points-and-diamonds-dialog"
        >
            <DialogContent className="points-and-diamonds-dialog__container">
                <IconButton
                    aria-label={t('Close')}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    className="points-and-diamonds-dialog__close"
                >
                    <CloseOutlined />
                </IconButton>

                <div className="points-and-diamonds-dialog__title">{t('Diamonds.Title')}</div>

                <div className="points-and-diamonds-dialog__description">{t('Diamonds.Description')}</div>

                <div className="points-and-diamonds-dialog__table-wrapper">
                    <table className="points-and-diamonds-dialog__table">
                        <thead>
                            <tr>
                                <th>{t('Diamonds.TableHeaderStatus')}</th>
                                <th>{t('Diamonds.TableHeaderPoints')}</th>
                                <th>{t('Diamonds.TableHeaderDiamonds')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {statusTiers.map((tier, index) => {
                                const StatusIcon = tier.icon;
                                return (
                                    <tr key={index}>
                                        <td>
                                            <div className="points-and-diamonds-dialog__status-cell">
                                                <StatusIcon className="points-and-diamonds-dialog__status-icon" />
                                                <span>{renderStatusLabel(tier.label, tier.colorClass)}</span>
                                            </div>
                                        </td>
                                        <td>
                                            {tier.points} {t('Points')}
                                        </td>
                                        <td>
                                            {tier.diamonds} {t('Diamond')}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <ul className="points-and-diamonds-dialog__bullets">
                    <li>{t('Diamonds.Bullet1')}</li>
                    <li>{t('Diamonds.Bullet2')}</li>
                    <li>{t('Diamonds.Bullet3')}</li>
                </ul>
            </DialogContent>
        </Dialog>
    );
};

export default PointsAndDiamondsDialog;
